<template>
    <div class="card-header">
        <h2 class="mb-0">
            <button 
                class="btn btn-link btn-block text-left d-flex align-items-center p-3"
                :class="{ 'text-muted': disabled }"
                @click="handleClick"
                :disabled="disabled"
                type="button"
                :aria-expanded="isActive"
                :aria-controls="'section-' + sectionId"
            >
                <!-- Chevron Icon -->
                <i class="fas fa-chevron-right mr-3 transition-icon"
                   :class="{ 'chevron-rotated': isActive }"
                ></i>
                
                <!-- Content -->
                <div class="d-flex justify-content-between align-items-center w-100">
                    <span class="h5 mb-0">
                        <slot name="title"></slot>
                    </span>
                    <slot name="badge"></slot>
                </div>
            </button>
        </h2>
    </div>
</template>

<script>
export default {
    name: 'AccordionHeader',
    
    props: {
        sectionId: {
            type: String,
            required: true
        },
        isActive: {
            type: Boolean,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        handleClick() {
            if (!this.disabled) {
                this.$emit('toggle', this.sectionId);
            }
        }
    }
}
</script>

<style scoped>
/* Remove default button styling */
.btn-link {
    text-decoration: none !important;
    box-shadow: none !important;
}

.btn-link:hover {
    text-decoration: none !important;
    /* background-color: #f8f9fa; */
}

.btn-link:focus {
    text-decoration: none !important;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25) !important;
}

/* Chevron transition */
.transition-icon {
    transition: transform 0.2s ease;
}

.chevron-rotated {
    transform: rotate(90deg);
}

/* Disabled state */
.btn-link:disabled {
    opacity: 0.65;
    pointer-events: none;
}
</style>